export default __webpack_public_path__ + "static/media/manishParihar.9079fa1f.jpg";